<template>
  <div class="font-secondary text-[12px] text-gray-500 leading-[20px] mb-1.5">
    {{ label }}
  </div>

  <div class="mb-[14px] relative">
    <div
      v-for="entry in entries"
      :key="entry.timestamp"
      class="font-secondary leading-[20px] flex"
    >
      <div class="min-w-[90px] text-gray-500 tabular-nums">
        {{ entry.timestamp }}
      </div>
      <div>{{ entry.text }}</div>
    </div>

    <div
      class="w-full h-10 bg-gradient-to-b from-transparent to-white absolute bottom-0 left-0"
    ></div>
  </div>

  <UiButton @click="handleViewMore">View more</UiButton>
</template>

<script setup lang="ts">
import type { TextWithTimestampPreview } from '@/shared/graphql/router/graphql'
import { UiButton } from '@dacr/ui'
import { useRoute, useRouter } from 'vue-router'

const props = withDefaults(
  defineProps<{
    entries: TextWithTimestampPreview[]
    trackIndex?: number
    label?: string
  }>(),
  { label: 'Transcript' }
)

const route = useRoute()
const router = useRouter()

const handleViewMore = () => {
  const base = `/file/${route.params.id}`
  if (props.trackIndex !== undefined) {
    router.push(`${base}/tracks/${props.trackIndex}/transcript`)
  } else {
    router.push(`${base}/transcript`)
  }
}
</script>
